import { BasicCommand } from "./BasicCommand";


import { BasicController } from "../BasicController";
import { BasicSmartfoxConstants } from "../BasicSmartfoxConstants";
import { ServerErrorVO } from "../clientCommands/vo/ServerErrorVO";
import { BasicErrorConstants } from "./constants/BasicErrorConstants";
import { BasicPaymentEvent } from "../../event/BasicPaymentEvent";
import { CommandController } from './../../../commanding/CommandController';

/**
 * S2C_NEW_CASH_HASH
 * */
export class NCHCommand extends BasicCommand {
    protected get cmdId(): string {
        return BasicSmartfoxConstants.S2C_NEW_CASH_HASH;
    }

    public executeCommand(error: number, params: any[]): boolean {
        if (error == BasicErrorConstants.ALL_OK) {
            // if params includes errorcode
            if (params.length == 2) {
                params.shift();
            }

            // Set "cash hash"
            BasicController.getInstance().paymentHash = String(params.shift());

            BasicController.getInstance().dispatchEvent(new BasicPaymentEvent(BasicPaymentEvent.PAYMENT_HASH_CHANGED));
        }
        else if (error == BasicErrorConstants.NO_PLAYER) {
            CommandController.instance.executeCommand(BasicController.COMMAND_HANDLE_SERVER_ERROR, new ServerErrorVO(error, params))
        }

        return false;
    }
}
